import { Fragment } from 'react';
import Layout from './../components/Layout/Layout';

import { Col, Container, Row } from 'react-bootstrap'

const Careers = () => {
   
    return (
        <Fragment>
            <Layout title='Careers' description='Careers Desc' >
                <section className='pt-[50px] md:pt-[80px] pb-0 relative overflow-hidden'>
                    <img src={ "/images/Container.svg"} className='absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none' alt="" />
                    <Container className='relative z-[1] mt-[3rem]'>
                        <h2 className='font-bold text__72 mb-4 text-black'>Careers <br />
                           </h2>
                        <p className='text__20 text-Mneutral700 leading-relaxed mb-4 sm:mb-[3rem]'>Join a movement where technology meets impact. At FuteurAI, we empower small businesses,  <br className='lg:block hidden' /> spark innovation, and shape a future where everyone thrives.</p>

                        <img src={"/images/Group 162645.svg"} className='mx-auto sm:block hidden' alt="" />
                        <img src={  "/images/Group 162654.svg"} className='mx-auto sm:hidden' alt="" />
                    </Container>
                </section>
                <section>
                    <div className="xs:px-2">
                        <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] rounded-[24px] sm:rounded-[56px] text-black">
                            <Container>
                                <div className="md:text-center mb-[2.5rem]">
                                    <h3 className='font-medium text__64 mb-2 text-black'>Why work with us?</h3>
                                    <p className='text__20 text-Mneutral500'>We prioritize people, foster innovation, and drive transformative change. Together, we’re creating a future that empowers small businesses, minorities, and women-led enterprises worldwide.</p>
                                </div>

                                <Row className='gap-y-4'>
                                    <Col md={6} lg={3} className='flex-fill'>
                                        <div className="h-full p-4 w-full bg-white border-b !border-Mneutral200">
                                            <div className="w-[56px] lg:w-[64px] h-[56px] lg:h-[64px] bg-Mneutral100 flex items-center justify-center rounded-xl mb-[2rem]">
                                                <img src={"/images/xcr (4).svg"} alt="" />
                                            </div>

                                            <h5 className='font-medium text__20 mb-2'>Innovation</h5>
                                            <p className='text__16 text-Mneutral700'>We leverage cutting-edge AI and technology to disrupt norms, create opportunities, and reimagine the future of business.</p>
                                        </div>
                                    </Col>
                                    <Col md={6} lg={3} className='flex-fill'>
                                        <div className="h-full p-4 w-full bg-white border-b !border-Mneutral200">
                                            <div className="w-[56px] lg:w-[64px] h-[56px] lg:h-[64px] bg-Mneutral100 flex items-center justify-center rounded-xl mb-[2rem]">
                                                <img src={"/images/xcr (1).svg"} alt="" />
                                            </div>

                                            <h5 className='font-medium text__20 mb-2'>Empowerment</h5>
                                            <p className='text__16 text-Mneutral700'>We enable small businesses, minority entrepreneurs, and women-led ventures to succeed while empowering our team to lead with impact.</p>
                                        </div>
                                    </Col>
                                    <Col md={6} lg={3} className='flex-fill'>
                                        <div className="h-full p-4 w-full bg-white border-b !border-Mneutral200">
                                            <div className="w-[56px] lg:w-[64px] h-[56px] lg:h-[64px] bg-Mneutral100 flex items-center justify-center rounded-xl mb-[2rem]">
                                                <img src={"/images/xcr (3).svg"} alt="" />
                                            </div>

                                            <h5 className='font-medium text__20 mb-2'>Collaboration</h5>
                                            <p className='text__16 text-Mneutral700'>We build together, blending diverse skills and perspectives to solve challenges and drive real-world results.</p>
                                        </div>
                                    </Col>
                                   
                                </Row>
                            </Container>
                        </div>
                    </div>
                </section>

                <section className='py-2'>
                    <div className="xs:px-2">
                        <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] rounded-[24px] sm:rounded-[56px] bg-Mneutral900">
                            <Container>
                                <Row className='justify-between'>
                                    <Col md={6} xl={5}>
                                        <h3 className='font-medium text__56 text-white mb-2'>Perks</h3>
                                        <p className='text__20 opacity-60 text-white'>We invest in you. Experience benefits designed to inspire growth, balance, and impact.</p>
                                    </Col>
                                    <Col md={6} xl={5}>
                                        <div className="grid grid-rows-1 gap-y-3">

                                            {
                                                [
                                                    {
                                                        icon: "/images/lex (3).svg",
                                                        title: "Flexible work environment to empower your creativity.",
                                                        desc: "We don’t mess around when it comes to paychecks.",
                                                    },
                                                    {
                                                        icon: "/images/lex (2).svg",
                                                        title: "Inclusive culture celebrating diverse perspectives and ideas.",
                                                        desc: "We’ve got you covered (literally).",
                                                    },
                                                    {
                                                        icon:  "/images/lex (1).svg",
                                                        title: "Initiatives supporting mental well-being and personal balance.",
                                                        desc: "Save for your future self. We'll help you get started.",
                                                    },
                                                    {
                                                        icon:  "/images/lex (4).svg",
                                                        title: "Professional growth opportunities tailored to your aspirations.",
                                                        desc: "Want to level up your skills? We'll chip in.",
                                                    },
                                                ].map((obj) => {
                                                    return <div className="flex items-start gap-4 py-[2rem] border-b !border-[rgba(229,229,229,0.2)]">
                                                        <div className="w-[56px] xl:w-[72px] h-[56px] xl:h-[72px] rounded-[10px] bg-[#2A2A2A] flex items-center justify-center flex-shrink-0">
                                                            <img src={obj.icon} alt="" />
                                                        </div>

                                                        <div className="">
                                                            <h5 className='font-medium text__24 mb-2 text-white'>{obj.title}</h5>
                                                           
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </section>
{/*
                <section className='py-2'>

                    <div className="px-2">
                        <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                            <Container>

                                <div className="text-center mb-[2.5rem]">
                                    <h3 className='font-medium text__64 mb-2 text-black'>Explore our latest job <br /> ⎯ listings</h3>
                                    <p className='text__20 text-Mneutral500'>We're looking for people who are:</p>
                                </div>

                                <div className="mb-6">
                                    <h4 className='font-medium text__24 mb-3 text-black'>Tech Industry</h4>

                                    <div className="grid grid-rows-1 gap-y-3 text-black">
                                        {
                                            [
                                                {
                                                    title: "Full Stack Developer",
                                                    status: "Full time",
                                                    location: "Manhattan, New York ",
                                                    link: "#!",
                                                },
                                                
                                            ].map((obj) => {
                                                return <div className="py-3 pl-8 pr-4 w-full border !border-Mneutral200 rounded-full grid-cols-3 grid md:grid-cols-5 items-center">
                                                    <div className="col-span-2">
                                                        <h5 className='font-medium text__20'>{obj.title}</h5>
                                                        <p className='text__16 text__700'>{obj.status}</p>
                                                    </div>
                                                    <div className="flex items-center gap-2 md:block hidden">
                                                        <img src={"/images/MapPin.svg"} alt="" />
                                                        <p className='text__14 text-Mneutral500'>{obj.location}</p>
                                                    </div>
                                                    <div className="text-center md:block hidden">
                                                        <div className="inline-block text-left">
                                                            <p className='text__16 text__500'>{obj.type}</p>
                                                         
                                                        </div>
                                                    </div>
                                                    <div className="w-full">
                                                        <a href={obj.link} className="w-[46px] md:w-[56px] h-[46px] md:h-[56px] rounded-full flex items-center justify-center bg-Mneutral50 border !border-Mneutral200 ml-auto inline-block">
                                                            <img src={"/images/arrowright.svg"} alt="" />
                                                        </a>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="mb-6">
                                    <h4 className='font-medium text__24 mb-3 text-black'>Marketing & Sales</h4>

                                    <div className="grid grid-rows-1 gap-y-3 text-black">
                                        {
                                            [
                                                {
                                                    title: "Marketing",
                                                    status: "Full time",
                                                    location: "Manhattan, New York ",
                                                    type: "Hourly",
                                                    price: "$44.75 - $56.00",
                                                    link: "#!",
                                                },
                                                
                                            ].map((obj) => {
                                                return <div className="py-3 pl-8 pr-4 w-full border !border-Mneutral200 rounded-full grid-cols-3 grid md:grid-cols-5 items-center">
                                                    <div className="col-span-2">
                                                        <h5 className='font-medium text__20'>{obj.title}</h5>
                                                        <p className='text__16 text__700'>{obj.status}</p>
                                                    </div>
                                                    <div className="flex items-center gap-2 md:block hidden">
                                                        <img src={"/images/MapPin.svg"} alt="" />
                                                        <p className='text__14 text-Mneutral500'>{obj.location}</p>
                                                    </div>
                                                    <div className="text-center md:block hidden">
                                                        <div className="inline-block text-left">
                                                           
                                                        </div>
                                                    </div>
                                                    <div className="w-full">
                                                        <a href={obj.link} className="w-[46px] md:w-[56px] h-[46px] md:h-[56px] rounded-full flex items-center justify-center bg-Mneutral50 border !border-Mneutral200 ml-auto inline-block">
                                                            <img src={"/images/arrowright.svg"} alt="" />
                                                        </a>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>

                            </Container>
                        </div>
                    </div>

                </section>
                */}
                <section className='py-2'>

                <div className="px-2">
                    <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                        <Container>

                            <Row className="justify-center">
                            <Col md={8} className="text-center">
                                <h3 className="font-medium text__64 mb-4 text-black mt-10">Contact Us</h3>
                                <p className="text__20 text-Mneutral500 mb-6">
                                    If you are interested in joining our team, feel free to send us your resume or ask questions at:
                                </p>
                                <a
                                    href="mailto:careers@futeur.ai"
                                    className="font-medium text__24 text-Msecondary500 underline hover:text-black transition"
                                >
                                    careers@futeur.ai
                                </a>
                                <p className="text__20 text-Mneutral500 mt-4 mb-20">
                                    We look forward to hearing from you!
                                </p>
                            </Col>
                        </Row>           
                        </Container>
                    </div>
                </div>

            </section>
              
            </Layout>
        </Fragment >
    )
}

export default Careers

